var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoShipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6965 32.014L16.293 28.3604V47.4942L35.2345 57.013L34.4653 37.3984L26.7733 33.5044V37.8792C26.7733 39.4176 25.6676 39.5939 25.283 39.5618C24.1773 39.4697 23.6965 38.7766 23.6965 37.8792V32.014Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7717 16.293L17.5898 25.3791L24.8492 29.0328L43.6945 19.6582L36.7717 16.293Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5829 34.7537L28.4102 30.8116L46.9671 21.3408L55.3802 25.4272L36.5829 34.7537Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0723 56.6761V37.5423L56.7253 28.0234V44.7054L38.0723 56.6761Z",
    fill: "#F2F2F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 34.5,
    stroke: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoShipment);
export default __webpack_public_path__ + "static/media/no-shipment.7c0c4b9778dc8c9cc8557400d9b04102.svg";
export { ForwardRef as ReactComponent };